import { render, staticRenderFns } from "./Classification.vue?vue&type=template&id=58d427df&scoped=true"
import script from "./Classification.vue?vue&type=script&lang=js"
export * from "./Classification.vue?vue&type=script&lang=js"
import style0 from "./Classification.vue?vue&type=style&index=0&id=58d427df&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d427df",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58d427df')) {
      api.createRecord('58d427df', component.options)
    } else {
      api.reload('58d427df', component.options)
    }
    module.hot.accept("./Classification.vue?vue&type=template&id=58d427df&scoped=true", function () {
      api.rerender('58d427df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/ComponentDetails/components/Interface/Classification.vue"
export default component.exports